import { LinkTabProps, Tab } from './types';
import { getRoleFromPath } from '../../utility/path';

export const getOrganizationTabLinks = ({ recordId, path }: LinkTabProps): Tab[] => {
  const role = getRoleFromPath(path);
  const tabs: Tab[] = [
    {
      label: 'Account',
      to: (recordId) ? `/dashboard/${role}/organizations/${recordId}/account`
        : '/dashboard/admin/organizations/new',
    },
  ];

  if (path.indexOf('/organizations/new') === -1) {
    tabs.push({
      label: 'Team',
      to: (recordId) ? `/dashboard/${role}/organizations/${recordId}/team` : '',
    });
    tabs.push({
      label: 'Billing',
      to: (recordId) ? `/dashboard/${role}/organizations/${recordId}/billing` : '',
    });
  }
  return tabs;
};
